import React from "react";
import { cn } from "../../../lib/utils";

interface SettingsCardProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

const SettingsCard: React.FC<SettingsCardProps> = ({
  title,
  description,
  action,
  className,
  bodyClassName,
  children,
}) => {
  return (
    <section
      className={cn(
        "overflow-hidden rounded-2xl border border-[#EEEFEA] bg-white shadow-[0_1px_2px_rgba(28,28,28,0.04)]",
        className
      )}
    >
      {(title || description || action) && (
        <header className="flex items-start justify-between gap-4 border-b border-[#F1F1EE] px-6 py-5">
          <div className="min-w-0">
            {title && (
              <h3 className="text-[16px] font-semibold text-hColor">{title}</h3>
            )}
            {description && (
              <p className="mt-1 text-[13px] leading-relaxed text-pColor">
                {description}
              </p>
            )}
          </div>
          {action}
        </header>
      )}
      <div className={cn("p-6", bodyClassName)}>{children}</div>
    </section>
  );
};

export default SettingsCard;
